import styles from "./filter-money.module.css";
import { useState, useEffect } from "react";
import { Checkbox, Flex, Space } from "antd";

import InputMoney from "@/components/inputs/InputMoney";
import CustomLabel from "@/components/inputs/CustomLabel";

const EMPTY_VALUE = "notFilled";

const FilterMoney = ({
  value,
  label,
  onSubmit,
  fromTo = true,
  allowEmpty = false,
}) => {
  const [val, setVal] = useState(value);
  const [isEmpty, setIsEmpty] = useState(value === EMPTY_VALUE);
  const [validity, setValidity] = useState({ from: true, to: true, value: true });

  useEffect(() => {
    setVal(value === EMPTY_VALUE ? null : value);
    setIsEmpty(value === EMPTY_VALUE);
  }, [value]);

  const handleSubmit = (nextVal = val, nextEmpty = isEmpty) => {
    const isValid = fromTo
      ? validity.from && validity.to
      : validity.value;
    if (!nextEmpty && !isValid) return;

    if (nextEmpty) {
      onSubmit?.(EMPTY_VALUE);
    } else {
      onSubmit?.(nextVal);
    }
  };

  const handleEmptyChange = (e) => {
    const checked = e.target.checked;
    setIsEmpty(checked);

    if (checked) {
      handleSubmit(null, true);
    } else {
      handleSubmit(val, false);
    }
  };

  return (
    <div>
      <CustomLabel text={label} />

      <Flex gap={8} align="center">
        {fromTo ? (
          <Space.Compact className="w-100">
            <InputMoney
              placeholder="от"
              value={val?.from}
              disabled={isEmpty}
              onValidate={(isValid) =>
                setValidity((prev) => ({ ...prev, from: isValid }))
              }
              onChange={(newValue) =>
                setVal((prev) => ({ ...prev, from: newValue }))
              }
              onPressEnter={() => handleSubmit()}
              onBlur={() => handleSubmit()}
              className={styles.inputMoney}
            />
            <InputMoney
              placeholder="до"
              value={val?.to}
              disabled={isEmpty}
              onValidate={(isValid) =>
                setValidity((prev) => ({ ...prev, to: isValid }))
              }
              onChange={(newValue) =>
                setVal((prev) => ({ ...prev, to: newValue }))
              }
              onPressEnter={() => handleSubmit()}
              onBlur={() => handleSubmit()}
              className={styles.inputMoney}
            />
          </Space.Compact>
        ) : (
          <InputMoney
            value={val}
            disabled={isEmpty}
            onValidate={(isValid) =>
              setValidity((prev) => ({ ...prev, value: isValid }))
            }
            onChange={(newValue) => setVal(newValue)}
            onPressEnter={() => handleSubmit()}
            onBlur={() => handleSubmit()}
            className={styles.inputMoney}
          />
        )}

        {allowEmpty && (
          <Checkbox
            style={{ width: 165 }}
            checked={isEmpty}
            onChange={handleEmptyChange}
          >
            Не заполнено
          </Checkbox>
        )}
      </Flex>
    </div>
  );
};

export default FilterMoney;
